// CMP-Toast chargé à la demande (budget JS initial ≤ 200 Ko, lot F7a) : sonner rejoue à son montage les toasts émis
// avant lui, aucun message n'est perdu.
import { lazy, Suspense } from 'react';

const Toaster = lazy(() => import('./Feedback').then((m) => ({ default: m.Toaster })));

export function LazyToaster() {
  return (
    <Suspense fallback={null}>
      <Toaster />
    </Suspense>
  );
}
